/**
 * Map of API response message keys to translated strings.
 * Used to translate backend message identifiers into user-facing text.
 */
export const API_MESSAGE_MAP: Record<string, Record<string, string>> = {
  'register.success': {
    it: 'Registrazione completata con successo!',
    en: 'Registration completed successfully!'
  },
  'verification.success': {
    it: 'Email verificata con successo!',
    en: 'Email verified successfully!'
  },
  'forgot-password.success': {
    it: 'Email di recupero password inviata con successo!',
    en: 'Password recovery email sent successfully!'
  },
  'reset-password.success': {
    it: 'Password reimpostata con successo!',
    en: 'Password reset successfully!'
  },
  'verification.email_sent': {
    it: 'Email di verifica inviata!',
    en: 'Verification email sent!'
  },
  'Email verified successfully': {
    it: 'Email verificata con successo!',
    en: 'Email verified successfully!'
  },
  'Password reset successfully': {
    it: 'Password reimpostata con successo!',
    en: 'Password reset successfully!'
  },
  'Verification email sent': {
    it: 'Email di verifica inviata!',
    en: 'Verification email sent!'
  }
}

/**
 * Translate an API response message using the locale.
 * Falls back to the original message if no translation is found.
 */
export const translateApiMessage = (message: string, locale?: string | null): string => {
  const translations = API_MESSAGE_MAP[message]
  if (!translations) return message
  return translations[locale || 'it'] || translations.it || message
}
